import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { keokukConfig } from "./data";

export default function KeokukPage() {
  return <CityPageTemplate config={keokukConfig} />;
}